export default "__VITE_ASSET__CFxh006Z__"